import * as React from "react"

import { cn } from "@/lib/utils"
import { DateField, MonthField } from "@/components/ui/date-field"

const Input = React.forwardRef(({ className, type, min, max, ...props }, ref) => {
  if (type === 'date') return <DateField className={className} min={min || '1920-01-01'} max={max || '2099-12-31'} {...props} />;
  if (type === 'month') return <MonthField className={className} min={min} max={max} {...props} />;
  const finalMin = min || (type === 'date' ? '1920-01-01' : type === 'month' ? '1920-01' : undefined);
  const finalMax = max || (type === 'date' ? '2099-12-31' : type === 'month' ? '2099-12' : undefined);
  return (
    <input
      type={type}
      min={finalMin}
      max={finalMax}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
